import React from "react";

const getViewBox = name => {
  switch (name) {
    case "trash":
      return "-3.377 0 32 32";
    case "add":
      return "0 0 31.714 32";
    case "pencil":
      return "0 0 31.311 31.92";
    case "pencil-and-paper":
      return "0 0 17.503 32";
    case "checkmark":
      return "0 0 32 32";
    case "x":
      return "0 0 28.246 32";
    default:
      return "0 0 32 32";
  }
};

const getPath = (name, props) => {
  switch (name) {
    case "trash":
      return (
        <>
          <path
            {...props}
            d="M24.752,3.076C24.296,2.43,20.25,2.283,15.58,2.424c0.092-0.661,0.243-2.061-0.051-2.333
            c-0.389-0.36-5.514,0.436-5.812,0.908C9.52,1.317,9.589,2.192,9.655,2.733c-4.782,0.351-8.934,0.91-9.284,1.455
            c-0.834,1.298,0,3.894,0,3.894s6.984-0.495,11.774-0.464c4.789,0.031,12.606,0.464,12.606,0.464S25.863,4.652,24.752,3.076z"
          />
          <path
            {...props}
            d="M22.744,10.06c-0.495-0.556-19.405-0.494-19.9,0c-0.446,0.446-0.59,16.514,0.021,20.258c0,0,0.037,1.002,0.586,1.471
            C4,32.255,22.803,31.91,23.201,31.164c0.142-0.264,0.229-0.535,0.291-0.789c0.031-0.062,0.057-0.195,0.076-0.393
            c0.054-0.361,0.045-0.621,0.045-0.621C23.805,25.257,23.178,10.549,22.744,10.06z M4.92,30.425
            c-0.066-4.071-0.229-15.387,0.024-15.792c0.31-0.494,2.658-0.371,2.968,0c0.243,0.293,0.449,11.279,0.524,15.871
            C7.045,30.494,5.846,30.46,4.92,30.425z M11.454,30.496c-0.1-4.01-0.354-15.456,0.036-15.863c0.474-0.494,3.162-0.371,3.636,0
            c0.367,0.289,0.679,10.938,0.799,15.65C14.023,30.412,13.107,30.475,11.454,30.496z M18.271,30.091
            c-0.069-4.325-0.217-15.063,0.029-15.458c0.311-0.494,2.657-0.371,2.969,0c0.229,0.276,0.426,10.068,0.51,15.031
            C20.611,29.837,19.438,29.979,18.271,30.091z"
          />
        </>
      );
    case "add":
      return (
        <>
          <path
            {...props}
            d="M31.714,10.039L20.41 11.675 21.024 0 9.866 2.736 10.537 13.104 0 14.629 0.689 22.177 11.107 21.9 11.761 32 19.339 32 19.884 21.668 30.003 21.4 z"
          />
        </>
      );
    case "pencil":
      return (
        <>
          <path
            {...props}
            d="M2.209,26.569c0,0-1.078,3.32-2.209,4.479c0,0,0.338,0.357,1.209,0.869c0,0,2.237-2.312,3.438-3.133
            C4.648,28.787,4.301,26.084,2.209,26.569z"
          />
          <path
            {...props}
            d="M30.305,4.062C26.391-3.411,19.98,1.715,19.98,1.715c8.543,2.505,7.371,13.036,7.371,13.036
            C33.951,10.838,30.305,4.062,30.305,4.062z"
          />
          <path
            {...props}
            d="M14.096,19.202c2.027-2.604,12.12-8.984,12.133-8.992c-0.438-1.187-0.944-2.162-1.488-2.966
            c-2.797,1.178-13.249,9.877-13.249,9.877c3.717-4.964,12.103-11.259,12.116-11.27c-2.716-2.761-5.761-2.262-5.761-2.262
            C12.734,8.257,6.18,16.194,3.714,19.244c-0.312,0.356-0.645,0.771-1.001,1.247c0,0,2.854-2.358,3.785-1.207
            c0.934,1.152,0.657,3.457,0.657,3.457s1.865-2.358,2.964-1.152c1.097,1.206,0.383,2.854,0,3.291c0,0,1.59-1.591,1.92-0.986
            c0.328,0.604,0.054,1.976-0.935,3.235c0,0,0.183-0.21,0.437-0.537c7.552-9.265,15.812-11.841,15.812-11.841
            c-0.166-1.094-0.377-2.079-0.621-2.972C22.965,13.326,14.096,19.202,14.096,19.202z"
          />
          <path
            {...props}
            d="M11.408,24.88c-0.057-0.438-1.289,0-1.289,0c0.19-0.438-0.083-1.617-0.604-2.275c-0.521-0.657-2.359,0.139-2.359,0.139
            c0-0.551-0.739-1.947-1.562-2.524c-0.821-0.573-2.88,0.274-2.88,0.274c0.356,3.1-0.504,6.076-0.504,6.076
            c4.367-1.647,2.438,2.22,2.438,2.22c2.881-1.698,6.457-1.658,6.457-1.658C11.929,25.729,11.408,24.88,11.408,24.88z"
          />
        </>
      );
    case "pencil-and-paper":
      return (
        <>
          <path
            {...props}
            d="M12.656,7.88L12.634 14.422 17.503 14.915z"
          />
          <path
            {...props}
            d="M5.81,17.688c0,0,0.969,0.402,1.325,0c0,0,0.356-2.646,2.141-4.291V2.249c0,0-0.662-2.396-3.109-2.242
            c-2.446,0.152-2.65,2.345-2.65,2.345s0.023,0.32,0.053,0.88c1.181,0.329,3.094,0.547,5.196-0.474c0,0-1.896,2.072-5.15,1.429
            c0.087,2.07,0.164,5.62-0.1,9.21C3.516,13.397,5.351,14.931,5.81,17.688z"
                    />
          <path
            {...props}
            d="M11.634,7.88h-1.575v6.062c-2.265,1.823-2.341,4.637-2.341,4.637c-0.453,0.444-2.406-0.097-2.406-0.097
            c-0.582-3.057-2.565-4.542-2.565-4.542c0.177-2.114,0.232-4.213,0.229-6.062H0c0,0,0.643,12.061,0,23.553
            c0,0,11.197,0.771,16.923,0.517l0.426-15.974l-6.092,0.095L11.634,7.88z M14.615,29.131L2.49,29.389v-1.283l12.125-1.025V29.131z
            M14.615,26.052L2.49,26.309V24.77l12.125-1.025V26.052z M14.615,20.663v2.053L2.49,22.973v-1.283L14.615,20.663z"
          />
        </>
      );
    case "checkmark":
      return(
        <>
          <path
            {...props}
            d="M0,17.027c0,0,5.284,6.065,11.059,14.973c0,0,8.807-12.232,20.941-20.942L25.541,0c0,0-8.857,10.588-14.776,21.333
	          c0,0-4.894-6.165-8.221-9.101L0,17.027z"
          />
        </>
      );
    case "x":
      return(
        <>
          <path
            {...props}
            d="M16.566,15.8c2.692-2.353,5.767-4.821,9.209-7.265L19.631,0c0,0-4.992,3.971-10.194,10.627
            C5.085,7.202,2.724,4.801,2.724,4.801L0,7.437c1.59,3.168,3.512,6.068,5.562,8.681C3.392,19.555,1.406,23.434,0,27.654l3.072,2.22
            c0,0,2.523-3.437,7.327-8.288C17.02,28.285,23.384,32,23.384,32l4.862-9.326C23.838,20.415,19.926,18.047,16.566,15.8z"
          />
        </>
      );
    default:
      return <path />;
  }
};

const SVGIcon = ({
  name = "",
  style = {},
  fill = "",
  viewBox = "",
  width = "100%",
  className = "svg-icon",
  height = "100%"
}) => (
    <svg
      width={width}
      style={style}
      height={height}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox || getViewBox(name)}
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      {getPath(name, { fill })}
    </svg>
  );

export default SVGIcon;